import type { User } from "@supabase/supabase-js";

export const getUserRole = (user: User) => {
  const {
    app_metadata: { user_role },
  } = user;

  return user_role;
};
